<template>
  <div class="container">
    <div class="back">
      <div :class="six === true ? 'six-activity-container' : 'activity-container'">
        <div v-if="six === true" class="six-logo">
          <img v-if="this.bigshotCode === 'fo5akt'" src="../assets/images/six/qq.png" />
          <img v-if="this.bigshotCode === 'wqoaaj'" src="../assets/images/six/fangzhi.png" />
          <img v-if="this.bigshotCode === '6o7c6z'" src="../assets/images/six/jidian.png" />
          <img v-if="this.bigshotCode === 'go23yz'" src="../assets/images/six/shitu.png" />
          <img v-if="this.bigshotCode === 'bod7cx'" src="../assets/images/six/wukuang.png" />
          <img v-if="this.bigshotCode === 'hofwsh'" src="../assets/images/six/yibao.png" />
        </div>

        <a class="register" :href="url">
          <img class="button-register" src="../assets/images/activity/button-register.png" />
        </a>

        <div class="activity-box" style="padding: 6% 2%">
          <div class="activity-title">
            <img src="../assets/images/activity/title-2-en.png" />
          </div>
          <div class="mdd-service">
            <ul>
              <li class="flex-box">
                <img src="../assets/images/activity/icon-myqc.png" />
                <div class="flex-1">
                  <div class="service-title">
                    MyQC Services
                  </div>
                  <p>
                    Quality Inspection, Factory Evaluation, Container Loading Supervision, Quality Problem Solving.
                  </p>
                </div>
                <a href="http://u3881206.viewer.maka.im/k/QVZJKVQ1">detail ></a>
              </li>
              <li class="flex-box">
                <img src="../assets/images/activity/icon-trace.png" />
                <div class="flex-1">
                  <div class="service-title">
                    NoFake Services
                  </div>
                  <p>
                    Anti-counterfeiting & trace to the source, protecting your IPR.
                  </p>
                </div>
                <a href="https://a.eqxiu.com/s/i3a6IR1C">detail ></a>
              </li>
              <li class="flex-box">
                <img src="../assets/images/activity/icon-wefinance.png" />
                <div class="flex-1">
                  <div class="service-title">
                    WeFinance Services
                  </div>
                  <p>
                    A helpful finance service to your suppliers, enabling them to accept your long payment term.
                  </p>
                </div>
                <a href="https://c.eqxiu.com/s/Jsdz12YM">detail ></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { wxShareConfig } from '../wx-config'
export default {
  name: 'login',
  data() {
    return {
      device: 'mobile',
      show: false,
      login: false,
      url: '',
      bigshotCode: '',
      six: false
    }
  },
  created() {
    if (document.body.clientWidth > 720) {
      this.device = 'web'
    }
  },
  mounted() {
    this.bigshotCode = this.$route.query.bigshot_code
    if (
      this.bigshotCode === 'fo5akt' ||
      this.bigshotCode === 'wqoaaj' ||
      this.bigshotCode === '6o7c6z' ||
      this.bigshotCode === 'go23yz' ||
      this.bigshotCode === 'bod7cx' ||
      this.bigshotCode === 'hofwsh'
    ) {
      this.six = true
    }
    console.log()
    this.url = `https://web.tradeaider.com/web/#/en-US/register?shareCodeType=2&bigshot_code=${this.bigshotCode}`
    this.shareToUser()
  },
  methods: {
    toback() {
      console.log(this.$router.go(-1))
    },
    shareToUser() {
      // 用户大礼包分享
      let that = this
      let imageUrl = 'https://static.tradeaider.com/share-bigshot-en2.png'
      let desc = 'Get VIP card, enjoy 2% off with no time limitation.'
      let url = window.location.href
      let obj = {
        title: 'TradeAider VIP card for you！',
        desc: desc,
        link: url,
        imgUrl: imageUrl
      }
      wxShareConfig(obj, that.success, that.fail)
    },
    success() {
      console.log('success')
    },
    fail() {
      console.log('fail')
    }
  }
}
</script>

<style scoped>
.flex-box {
  display: flex;
  display: -moz-box-flex; /* Firefox */
  display: -webkit-flex; /* Safari 和 Chrome  */
  justify-content: center;
  align-items: center;
}

.flex-1 {
  -moz-box-flex: 1; /* Firefox */
  -webkit-box-flex: 1; /* Safari 和 Chrome */
  flex: 1;
}

.flex-2 {
  -moz-box-flex: 2; /* Firefox */
  -webkit-box-flex: 2; /* Safari 和 Chrome */
  flex: 2;
}

.flex-3 {
  -moz-box-flex: 3; /* Firefox */
  -webkit-box-flex: 3; /* Safari 和 Chrome */
  flex: 3;
}

.flex-4 {
  -moz-box-flex: 4; /* Firefox */
  -webkit-box-flex: 4; /* Safari 和 Chrome */
  flex: 4;
}

img {
  width: 100%;
}

.back {
  background: -webkit-linear-gradient(#f12f24, #fe9002); /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(#f12f24, #fe9002); /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(#f12f24, #fe9002); /* Firefox 3.6 - 15 */
  background: linear-gradient(#f12f24, #fe9002); /* 标准的语法 */
  padding: 4%;
}

.activity-container {
  position: relative;
  padding-top: 125%;
  background-image: url('../assets/images/activity/activity-banner-club.png');
  background-size: contain;
  background-repeat: no-repeat;
}

.six-activity-container {
  position: relative;
  padding-top: 125%;
  background-image: url('../assets/images/activity/six-activity-banner-en.png');
  background-size: contain;
  background-repeat: no-repeat;
}

.activity-box {
  background-color: #fff;
  border-radius: 10px;
  padding: 6%;
  text-align: center;
  position: relative;
  margin-bottom: 6%;
}

.activity-title {
  position: absolute;
  top: -10px;
  width: 66%;
  margin: 0 auto;
  left: 0;
  right: 0;
}

.coupon {
  padding-top: 50px;
}

.coupon-note {
  color: #ff2c2a;
  text-align: center;
  padding: 10% 0 1%;
  font-size: 12px;
}

.button-register {
  width: 95%;
  margin: 0 auto;
  position: relative;
  animation: mymove 3s infinite;
  -webkit-animation: mymove 3s infinite; /*Safari and Chrome*/
  animation-direction: alternate; /*轮流反向播放动画。*/
  animation-timing-function: ease-in-out; /*动画的速度曲线*/
  /* Safari 和 Chrome */
  -webkit-animation: mymove 3s infinite;
  -webkit-animation-direction: alternate; /*轮流反向播放动画。*/
  -webkit-animation-timing-function: ease-in-out; /*动画的速度曲线*/
}

@keyframes mymove {
  0% {
    transform: scale(1); /*开始为原始大小*/
  }
  25% {
    transform: scale(1.2); /*放大1.1倍*/
  }
  50% {
    transform: scale(1);
  }
  75% {
    transform: scale(1.2);
  }
}

@-webkit-keyframes mymove /*Safari and Chrome*/ {
  0% {
    transform: scale(1); /*开始为原始大小*/
  }
  25% {
    transform: scale(1.2); /*放大1.1倍*/
  }
  50% {
    transform: scale(1);
  }
  75% {
    transform: scale(1.2);
  }
}

.button-mdd {
  padding: 3%;
  display: block;
  width: 80%;
  margin: 2% auto;
  border: 1px solid #f33c24;
  border-radius: 50px;
  color: #f33c24;
}

.van-popup {
  background-color: transparent;
  width: 100%;
}

.success-contain {
  width: 100%;
  background-color: transparent;
  padding: 10%;
  position: relative;
}

.success-close {
  position: absolute;
  top: 6%;
  right: 8%;
  width: 9%;
}

.success-btn {
  position: absolute;
  bottom: 14%;
  text-align: center;
  width: 100%;
  left: 0;
  right: 0;
}

.success-btn img {
  width: 66%;
}

.mdd-service {
  padding-top: 50px;
  text-align: left;
}
.mdd-service li {
  background: rgba(249, 245, 244, 1);
  padding: 5%;
  border-radius: 100px;
  margin-bottom: 4%;
}
.mdd-service img {
  width: 66px;
}
.mdd-service .flex-1 {
  padding: 0 2%;
  font-size: 13px;
}
.mdd-service p {
  padding-top: 2%;
  font-size: 12px;
  color: #666;
}
.mdd-service a {
  color: #f33c24;
  padding: 5px 10px;
  border: 1px solid #f33c24;
  border-radius: 20px;
  font-size: 14px;
}

.register {
  width: 80%;
  display: block;
  margin: 5% auto 10%;
}

.service-title {
  font-size: 15px;
}

.six-logo {
  width: 40px;
  position: absolute;
  top: 0;
  right: 2%;
}
</style>
